import { Stack } from '@mui/material';
import { useLocationsTrendsQuery } from 'api/reports-service/reports-service';
import JobsStatusGate from 'components/jobs-status-gate/jobs-status-gate.component';
import { useDrawer } from 'components/drawers/inc-drawer/inc-drawer.hooks';
import LoyaltyPerformanceHeader from 'components/loyalty-performance-header/loyalty-performance-header.component';
import SearchToolbar from 'components/search/search-toolbar/search-toolbar.component';
import {
  MultipleSearchQueryProvider,
  SearchParamsProvider,
} from 'components/search/search.context';
import {
  useSearchParams,
  useSearchQuery,
} from 'components/search/search.hooks';
import { useLocationLoyaltyTrendsSearchParams } from '../loyalty-performance-report.hooks';
import LocationLoyaltyTrendsLineChart from './location-loyalty-trends-line-chart/location-loyalty-trends-line-chart.component';
import LocationLoyaltyTrendsAPIDetailsDrawer from 'components/drawers/location-loyalty-trends-api-details-drawer/location-loyalty-trends-api-details-drawer.component';
import { useTranslation } from 'react-i18next';
import {
  LocationTrendsParams,
  LoyaltyPerformanceParamsDiff,
} from 'api/reports-service/reports-service.types';
import TrendsDataGrid from 'pages/loyalty-performance-report/trends-data-grid/trends-data-grid.component';
import { useGetTrendsSearchResults } from 'pages/loyalty-performance-report/trends-data-grid/trends-data-grid.hooks';
import { getMaxColumns } from 'pages/loyalty-performance-report/trends-data-grid/trends-data-grid.utils';

const SearchParamsWrapper = () => {
  const searchParams = useSearchParams(useLocationLoyaltyTrendsSearchParams());
  return (
    <SearchParamsProvider value={searchParams}>
      <LocationLoyaltyTrends />
    </SearchParamsProvider>
  );
};

const filteredSearchParams: LoyaltyPerformanceParamsDiff<LocationTrendsParams> =
  [
    'comparisonstartdate',
    'comparisonenddate',
    'offerIds',
    // 'offerstatus',
    // 'campaignId',
    'sortBy',
    'sortDirection',
    'offertype',
  ];

const LocationLoyaltyTrends = () => {
  const { t } = useTranslation();
  const { open, close, isOpen } = useDrawer();
  const { getSearchResults } = useGetTrendsSearchResults();
  const locationsTrends = useSearchQuery(useLocationsTrendsQuery, {
    filteredSearchParams,
    getPaging: data => data?.dataGrid?.paging,
    getSearchResults: data =>
      getSearchResults(
        data?.dataGrid?.stores,
        data?.dataGrid?.total,
        'storeId',
      ),
  });

  return (
    <Stack marginTop={2}>
      <MultipleSearchQueryProvider
        value={{
          queries: {
            locationsTrends,
          },
        }}
      >
        <SearchToolbar />
        <Stack>
          <LoyaltyPerformanceHeader open={open} />
        </Stack>
        <Stack gap={2}>
          <LocationLoyaltyTrendsLineChart />
          <TrendsDataGrid
            queryName="locationsTrends"
            displayInfoHeaderName={t(
              'page.loyaltyPerformanceReport.tabs.locationLoyaltyTrends.grid.locationName.label',
            )}
            data-testid="LocationLoyaltyTrends.SearchDataGrid"
            maxColumns={getMaxColumns(
              locationsTrends.data?.dataGrid?.stores ?? [],
            )}
          />
        </Stack>
      </MultipleSearchQueryProvider>
      <LocationLoyaltyTrendsAPIDetailsDrawer isOpen={isOpen} close={close} />
    </Stack>
  );
};

export default function GatedPage() {
  return (
    <JobsStatusGate>
      <SearchParamsWrapper />
    </JobsStatusGate>
  );
}
